import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useField, useFormState } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import { Input } from '../../../../../components/common-inputs';
import SocialFieldWrapper from './SocialFieldWrapper';
import { SOCIAL_FIELDS } from '../constants';
import CommonButton from '../../../../../components/common-button/CommonButton';
import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';
import { crawlAllMedia, crawlSingleMedia } from '../../../../../redux/create-sonar/createSonarActions';
import CrawlLoader from '../../../../../components/crawl-loader-overlay/CrawlLoader';

import scss from '../SonarDatasetModal.module.scss';

const SocialSection = () => {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();

  const isCrawling = useSelector((state) => state.createSonar.isCrawling);
  const isEditableDatasetLoading = useSelector((state) => state.sonarManagement.isEditableDatasetLoading);
  const { submitting } = useFormState();

  const disableFields = isEditableDatasetLoading || submitting;

  const {
    input: { value: domainValue },
  } = useField('domain');

  const handleCrawlAllMissing = () => {
    dispatch(crawlAllMedia({ domain: domainValue }));
  };

  const handleCrawlSingleMedia = (socialMedia) => {
    dispatch(crawlSingleMedia({ socialMedia, domain: domainValue }));
  };

  return (
    <div className={scss.formSectionContent}>
      {SOCIAL_FIELDS.map(({ label, fieldKey }) => (
        <Field key={fieldKey} name={fieldKey}>
          {({ input, meta }) => (
            <SocialFieldWrapper
              label={label}
              fieldKey={fieldKey}
              isShowError={meta.touched && meta.error}
              errorText={t(meta.error)}
              onCrawl={handleCrawlSingleMedia}
              disabled={disableFields}>
              <Input size='sm' formProps={input} isError={meta.touched && meta.error} disabled={disableFields} />
            </SocialFieldWrapper>
          )}
        </Field>
      ))}

      <div style={{ marginTop: '20px' }}>
        <CommonButton
          styleColor='secondary'
          onClick={handleCrawlAllMissing}
          maxWidth={150}
          isStrokeIcon
          disabled={disableFields}>
          <Icon icon={ICONS.Scan} /> {t('crawlMissing')}
        </CommonButton>
      </div>

      <CrawlLoader isLoading={isCrawling} />
    </div>
  );
};

export default memo(SocialSection);
